export default "__VITE_ASSET__7b3bc175__"